import { Fragment } from 'react';

import { useTranslation } from 'react-i18next';
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';

export default function CirclePercentage ({ current, total }: { current: number; total: number; }) {
  const { t } = useTranslation();
  const percentage = (current * 100) / total;
  return (
    <Fragment>
      <div style={{ width: 200, height: 200, backgroundColor: 'white', borderRadius: '50%' }}>
        <CircularProgressbarWithChildren
          value={percentage}
          styles={buildStyles({
            pathColor: '#80B6E0',
            backgroundColor: '#80B6E0',
          })}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#006EC2' }}>
            <strong style={{ fontSize: '40px' }}>{percentage.toFixed(1)}%</strong>
            <span style={{ fontSize: '18px' }}>{t('Completed rate')}</span>
          </div>
        </CircularProgressbarWithChildren>
      </div>
      <div
        style={{
          width: '200px',
          textAlign: 'center',
          color: '#006EC2',
          fontSize: '28px',
          fontWeight: 'bold',
          margin: '23px 0px 0px 0px',
        }}
      >
        {current}/{total}
      </div>
    </Fragment>
  );
}
